import { render, staticRenderFns } from "./Question6.vue?vue&type=template&id=dc59b8b8"
import script from "./Question6.vue?vue&type=script&lang=js"
export * from "./Question6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports